import { Toaster as HotToaster } from 'react-hot-toast';

const toastBase = {
  background: 'rgb(var(--panel))',
  color: 'rgb(var(--text))',
  border: '1px solid rgb(var(--border))',
  boxShadow: '0 1px 3px rgb(15 23 42 / 0.06), 0 4px 16px rgb(15 23 42 / 0.08)',
};

const accentToast = (token: string) => ({
  ...toastBase,
  borderLeft: `4px solid rgb(var(${token}))`,
  borderRadius: '0 12px 12px 0',
});

export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        className: '',
        duration: 4000,
        style: {
          ...toastBase,
          borderRadius: '12px',
          padding: '16px 20px',
          fontSize: '14px',
          fontWeight: '500',
        },

        success: {
          duration: 4000,
          style: accentToast('--success'),
          iconTheme: { primary: 'rgb(var(--success))', secondary: 'rgb(var(--panel))' },
        },

        error: {
          duration: 5000,
          style: accentToast('--danger'),
          iconTheme: { primary: 'rgb(var(--danger))', secondary: 'rgb(var(--panel))' },
        },

        loading: {
          style: accentToast('--gold'),
          iconTheme: { primary: 'rgb(var(--gold))', secondary: 'rgb(var(--panel))' },
        },

        blank: {
          style: accentToast('--info'),
        },
      }}
    />
  );
}
